import React from 'react';
import moment from 'moment';
import { Flex, Space, Image, Typography } from 'antd';

import { logoStruct, headlineStruct } from './struct';

import IUBImg from './images/iub.png';

const { Title, Text } = Typography;
const { logoSection, logo } = logoStruct;
const { headlineSection } = headlineStruct;

export const BrandLogo = () => {
  return (
    <div {...logoSection}>
      <Flex align="center">
        <Space size="middle" align="center">
          <Image {...logo} src={IUBImg} preview={false} />
          <Text strong style={{ fontSize: '16px', color: '#5a5ab5' }}>
            Independent University, Bangladesh
          </Text>
        </Space>
      </Flex>
    </div>
  );
};

export const BrandHeadline = () => {
  return (
    <Flex {...headlineSection}>
      <Title 
        level={4} 
        style={{ 
          margin: 0, 
          color: '#1a1a2e',
          fontWeight: 600 
        }}
      >
        Annual Performance Appraisal
      </Title>
      <Text
        type="danger"
        strong
        style={{
          fontSize: '15px',
          // padding: '12px 16px',
          // background: '#fff1f0',
          // border: '1px solid #ffccc7',
          // borderRadius: '6px',
          display: 'inline-block',
          lineHeight: '1.6',
        }}
      >
        Providing false or misleading information may cause termination of your employment permanently.
      </Text>
      <Text 
        type="secondary" 
        style={{ 
          fontSize: '14px',
          fontStyle: 'italic',
          marginTop: '2px'
        }}
      >
        {moment(new Date()).format('MMMM DD, YYYY')}
      </Text>
    </Flex>
  );
};